export default __webpack_public_path__ + "static/media/van_filled.7ca70492.svg";